import { Box } from '@mui/material';

import DetailsItem from '../../../../../../common/details-item';
import { formatDateToClientFormat } from '../../../../../../../constants/helpers/dates';
import { reportDetailsFilterValuesFormatter } from '../../../../../../../utils/details';

import locales from '../locales';
import { PayoutReportDetailsMetadataResponse } from '../interfaces';

interface Props {
  filters: PayoutReportDetailsMetadataResponse;
}

const FilterDetails = ({ filters }: Props) => (
  <Box>
    <DetailsItem
      label={locales.details.startingDate.label}
      value={formatDateToClientFormat({ date: filters.timeRange.from })}
    />
    <DetailsItem
      label={locales.details.endDate.label}
      value={formatDateToClientFormat({ date: filters.timeRange.to, type: 'exclusive' })}
    />
    <DetailsItem label={locales.details.statuses.label} value={reportDetailsFilterValuesFormatter(filters.statuses)} />
    <DetailsItem
      label={locales.details.operationIds.label}
      value={reportDetailsFilterValuesFormatter(filters.operationIds)}
    />
  </Box>
);

export default FilterDetails;
